var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('feedback',{attrs:{"patient":_vm.patient,"creditNote":_vm.selectedCreditNote}})}
var staticRenderFns = []

export { render, staticRenderFns }